module.exports = __webpack_public_path__ + "img/chinesecompany44.e2cbe97a.png";